import { Alert, Box, Skeleton } from '@mui/material'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import Estructura from '../components/Estructura'
import OrganigramaReducido from '../components/OrganigramaReducido'
import useFetchOrganigrama from '../hooks/useFetchOrganigrama'

const SkeletonNivel = ({ ml = 0, empleados = 2 }) => (
  <Box
    sx={{
      ml,
      mb: 2,
      p: 2,
      border: 1,
      borderColor: 'divider',
      borderRadius: 2,
    }}
  >
    <Skeleton variant="text" width="40%" height={28} sx={{ mb: 1 }} />
    {Array.from({ length: empleados }).map((_, i) => (
      <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 0.5 }}>
        <Skeleton variant="circular" width={32} height={32} />
        <Skeleton variant="text" width="60%" height={24} />
      </Box>
    ))}
  </Box>
)

SkeletonNivel.propTypes = {
  ml: PropTypes.number,
  empleados: PropTypes.number,
}

const OrganigramaSkeleton = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
    <SkeletonNivel empleados={1} />
    <SkeletonNivel ml={4} empleados={2} />
    <SkeletonNivel ml={8} empleados={1} />
    <SkeletonNivel ml={8} empleados={3} />
  </Box>
)

const Organigrama = ({ allowReducido = false }) => {
  const location = useLocation()
  const { response, reducido, loading, error } = useFetchOrganigrama(location?.state?.user ?? null)

  if (loading) {
    return <OrganigramaSkeleton />
  }

  if (error) {
    return (
      <Alert severity="warning">
        No hemos podido obtener el organigrama para este usuario. Puede que se encuentre mal
        parametrizado
      </Alert>
    )
  }

  if (allowReducido && reducido === 'S') {
    return <OrganigramaReducido response={response} />
  }

  return <Estructura response={response} />
}

Organigrama.propTypes = {
  allowReducido: PropTypes.bool,
}

export default Organigrama
